import { Box } from '@mui/material';
import { Outlet } from 'react-router';
import './layout.scss';
import 'react-toastify/dist/ReactToastify.css';
import useLoadingStore from './store/LoadingStore';
import SideNav from './components/Navigation/SideNav/SideNav';
import Loader from './components/Loader/Loader';

const Layout = () => {
  //TODO enable loader
  const { isLoading } = useLoadingStore();

  return (
    <Box className="layout">
      <Box className="layout__sidebar">
        <SideNav />
      </Box>
      <Box className="layout__main-content">
        <Outlet />
      </Box>
      {isLoading && <Loader />}
    </Box>
  );
};

export default Layout;
